import {Component, Injector, OnInit, ViewChild} from "@angular/core";
import { AppComponentBase } from '@shared/app-component-base';
import {
    AuditLogServiceProxy,
    EntityChangeListDto,
    EntityPropertyChangeDto,
} from '@shared/service-proxies/service-proxies';
import { ModalDirective } from 'ngx-bootstrap/modal';
import * as moment from "@node_modules/moment";
import {BsModalRef} from "@node_modules/ngx-bootstrap/modal";

@Component({
    templateUrl: './entity-change-detail-modal.component.html',
})
export class EntityChangeDetailModalComponent extends AppComponentBase implements OnInit{
    @ViewChild('entityChangeDetailModal', { static: true }) modal: ModalDirective;

    active = false;
    entityPropertyChanges: EntityPropertyChangeDto[];
    entityChange: EntityChangeListDto;

    constructor(
        injector: Injector,
        private _auditLogService: AuditLogServiceProxy,
        public bsModalRef: BsModalRef
    ) {
        super(injector);
    }

    getPropertyChangeValue(propertyChangeValue, propertyTypeFullName) {
        if (!propertyChangeValue) {
            return propertyChangeValue;
        }
        propertyChangeValue = propertyChangeValue.replace(/^['"]+/g, '').replace(/['"]+$/g, '');
        if (this.isDate(propertyChangeValue, propertyTypeFullName)) {
            return moment(propertyChangeValue).format(
                'YYYY-MM-DD hh:mm:ss'
            );
        }

        if (propertyChangeValue === 'null') {
            return '';
        }

        return propertyChangeValue;
    }

    isDate(date, propertyTypeFullName): boolean {
        return propertyTypeFullName.includes('DateTime') && !isNaN(Date.parse(date).valueOf());
    }

    close(): void {
        this.active = false;
        this.bsModalRef.hide();
    }

    ngOnInit(): void {
        const self = this;
        self.active = true;

        this._auditLogService.getEntityPropertyChanges(self.entityChange.id).subscribe((result) => {
            self.entityPropertyChanges = result;
        });
    }
}
